import classNames from 'classnames';
import Card from 'components/Card';
import DataItem from 'components/DataItem';
import SubSectionLabel from 'components/typography/SubSectionLabel';
import { getAllFlightSegments } from 'shared/helpers/quoteBooking';
import AccommodationItem from './AccommodationItem';
import PackagesFlightItem from './PackagesFlightItem';

export default function PackagesItem({
  index,
  holidayNumber,
  freeChildPlaces,
  inclusions,
  accommodationList = [],
  flightList = [],
}) {
  const allFlightSegments = getAllFlightSegments(flightList);

  return (
    <Card cardTitle={`Package ${index + 1}`}>
      <div className="flex flex-wrap pb-3 mx-4 pt-[22px]">
        <DataItem label="Holiday Number" value={holidayNumber} />
        <DataItem label="Free Child Places" value={freeChildPlaces} />
        <DataItem
          label="Inclusion"
          value={inclusions}
          containerClassName="my-3 grow"
        />
      </div>

      {accommodationList?.length >= 1 && (
        <div className="mx-4">
          <div className="flex items-center">
            <SubSectionLabel label="Accommodation" />
          </div>
          {accommodationList.map((accommodation, acIndex) => (
            <div
              key={`${acIndex + 1}`}
              className={classNames('pb-4', { 'mt-10': acIndex !== 0 })}
            >
              <AccommodationItem accommodation={accommodation} isPackage />
            </div>
          ))}
        </div>
      )}

      {allFlightSegments?.length >= 1 && (
        <div className="mx-4">
          <div className="flex items-center mb-2">
            <SubSectionLabel label="Travel" />
          </div>
          {allFlightSegments.map((flightSegment, fIndex) => (
            <div
              key={`${fIndex + 1}`}
              className={classNames('pb-4', { 'mt-10': fIndex !== 0 })}
            >
              <PackagesFlightItem flightSegment={flightSegment} />
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
